import Vue from 'vue'
import VueResource from 'vue-resource'

Vue.use(VueResource)

export const RecommendationResource = () => {
  return Vue.resource('recommendations{/id}')
}



// WEBPACK FOOTER //
// ./src/api/recommendation.js